/**
 *****************************************
 *										*
 * NAGARRO  - CSX - CONFIDENTIAL         *
 *										*
 *****************************************
 */

import { map } from 'rxjs/operators';

import * as _ from "lodash";

import { AppUtilityService } from "../../core/services/app-utility.service";
import { BehaviorSubject ,  Observable } from "rxjs";
import { ConfigService } from "../../core/services/config.service";
import { DataStoreService } from "../../core/services/datastore.service";
import { EditModeService } from "./../../core/services/edit-mode.service";
import { HttpStatus } from "../../core/model/http-status-enum.model";
import { Injectable } from "@angular/core";
import { LmsLoaderService } from "./../../core/services/lms-loader.service";
import { LmsLoggerService } from "../../core/services/lms-logger.service";
import { LocoFeatureList } from "../../core/model/loco-feature-list-model";
import { LocoTransfer } from "../../core/model/loco-transfer.model";
import { MessageDetails } from "../../core/model/message-details.model";
import { MessageHandlerService } from "../../core/services/message-handler.service";
import { PopupService } from "../../core/services/popup.service";
import { Router } from "@angular/router";
import { StaticDataStoreService } from "./../../core/services/static-datastore.service";
import { Tab } from "../../core/model/tab.model";
import { TabData } from "../../core/model/tab-data.model";
import { TrainCancelComplete } from "../../core/model/train-cancel-complete.model";
import { TrainData } from "../../core/model/train-data.model";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { tap } from "rxjs/operators";

/**
 * This TrainDataService is created for fetch train related information from http service call.
 * @export
 * @class TrainDataService
 */
@Injectable()
export class TrainDataService {
  commonopsPicklist: any;
  loadData: Observable<TrainData>;
  private loadDataBS: BehaviorSubject<TrainData>;
  private RESOURCE_URL = "/trains/";
  private configData = this.configService.getConfigData();
  locoFeatureListArr: Array<LocoFeatureList>;

  /**
   * Creates an instance of TrainDataService and inject HttpClient, ConfigService, DataStoreService,
   * LmsLoggerService.
   * @param {HttpClient} http
   * @param {ConfigService} configService
   * @param {DataStoreService} dataStoreService
   * @param {LmsLoggerService} lmsLoggerService
   * @memberOf TrainDataService
   */
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private dataStoreService: DataStoreService,
    private lmsLoggerService: LmsLoggerService,
    private router: Router,
    private lmsLoaderService: LmsLoaderService,
    private messageHandlerService: MessageHandlerService,
    private staticDataStoreService: StaticDataStoreService,
    private popupService: PopupService,
    private editModeService: EditModeService,
    private appUtilService: AppUtilityService
  ) {
    this.loadDataBS = <BehaviorSubject<TrainData>>new BehaviorSubject({});
    this.loadData = this.loadDataBS.asObservable();
  }

  private isNumeric(value: string): boolean {
    const v = value.match(/^\d+$/);
    if (v) {
      if (v.toString() === value) {
        return true;
      }
    }
    return false;
  }

  isValidTrainId(value: string): boolean {
    let flag = false;
    if (value && value.length === 6) {
      if (!this.isNumeric(value.charAt(0))) {
        const remainingStr = value.substring(1, value.length);
        if (this.isNumeric(remainingStr)) {
          flag = true;
        }
      }
    }
    return flag;
  }

  private resetDefaultPageMode() {
    this.popupService.setPageMode("");
    this.popupService.setSubmitBtnId("");
  }

  /**
   * This method invoked when we required to fetch data either from http service
   * or datastore.
   * @param {Tab} tab
   * @param {boolean} isRefresh
   * @memberOf TrainDataService
   */
  load(tab: Tab, fromOtherOperation?: boolean, messageText?: string) {
    this.resetDefaultPageMode();
    let trainData: TrainData;
    let foundInDataStore = false;
    const locateLocoId = tab.locateLocoId;
    tab.locateLocoId = null;
    if (tab && tab.tabSearchParameter) {
      if (tab.tabSearchParameter.searchText) {
        tab.tabSearchParameter.searchText =
          tab.tabSearchParameter.searchText.trim();
      } else {
        this.lmsLoaderService.hideLoader();
        return;
      }
      if (tab.subTypeDetail[tab.subType.toLowerCase()].status === "error") {
        this.lmsLoaderService.hideLoader();
        return;
      }
      if (!this.isValidTrainId(tab.tabSearchParameter.searchText)) {
        const lTrainData = <TrainData>{
          httpStatus: 400,
          errorMessage:
            this.configService.getConfigData().messages.invalidFormatTrain,
        };
        this.loadDataBS.next(lTrainData);
        this.lmsLoggerService.logError(
          "TrainDataService => load()",
          this.configService.getConfigData().messages.invalidFormatTrain
        );
        this.lmsLoaderService.hideLoader();
      } else {
        if (tab.subTypeDetail[tab.subType.toLowerCase()].status !== "refresh") {
          const tabData = this.dataStoreService.getValue(tab);
          if (tabData) {
            trainData = <TrainData>tabData.data[tab.subType];
            foundInDataStore = true;
            this.loadDataBS.next(trainData);
          }
          this.lmsLoaderService.hideLoader();
        } else {
          foundInDataStore = false;
        }
        if (!foundInDataStore) {
          this.handleServiceCallForLoad(
            tab,
            fromOtherOperation,
            messageText,
            locateLocoId
          );
        }
      }
    } else {
      this.lmsLoaderService.hideLoader();
      this.loadDataBS.next(null);
    }
  }

  /**
   * helper method for load method
   * @private
   * @param {Tab} tab
   * @param {boolean} fromOtherOperation
   * @param {string} [messageText]
   * @memberof TrainDataService
   */
  private handleServiceCallForLoad(
    tab: Tab,
    fromOtherOperation: boolean,
    messageText?: string,
    locateLocoId?: string
  ) {
    this.lmsLoaderService.showLoader();
    const opr = "INQU";
    this.lmsLoggerService.logInfo("TrainDataService=>load service call starts");
    this.http
      .get(
        `${this.configService.getConfigData().urls.API_URL}${
          this.RESOURCE_URL
        }${tab.tabSearchParameter.searchText}?opr=${opr}`
      )
      .subscribe(
        (data) => {
          this.subscribeData(
            data,
            tab,
            fromOtherOperation,
            messageText,
            locateLocoId
          );
        },
        (error) => {
          const lTrainData = <TrainData>{
            httpStatus: error.status,
            errorMessage: fromOtherOperation
              ? messageText +
                ", but an error has occurred while refreshing the page."
              : this.appUtilService.getHttpErroMessage(error, false),
          };
          this.loadDataBS.next(lTrainData);
          this.lmsLoggerService.logError(
            "TrainDataService => load()",
            this.appUtilService.getHttpErroMessage(error, false)
          );
          this.lmsLoaderService.hideLoader();
        }
      );
  }

  /**
   * helper method for load method
   * @private
   * @param {*} data
   * @param {Tab} tab
   * @param {boolean} fromOtherOperation
   * @param {string} [messageText]
   * @memberof TrainDataService
   */
  private subscribeData(
    data: any,
    tab: Tab,
    fromOtherOperation: boolean,
    messageText?: string,
    locateLocoId?: string
  ) {
    if (data && data.priorityCode) {
      const pCode = parseInt(data.priorityCode, 10);
      if (pCode >= 1 && pCode <= 4) {
        // if (data.trainData) {
        //     data.trainData.locoDetails = this.appUtilService.prepareLocomotiveFeatureList(data.trainData.locoDetails);
        // }
        const lTrainData = <TrainData>data.trainData;
        lTrainData.trainIdentifier = tab.tabSearchParameter.searchText;
        const tabData = <TabData>{
          id: tab.id,
          subType: tab.subType,
        };

        tabData.data = tabData.data ? tabData.data : {};
        tabData.data[tab.subType] = lTrainData;

        lTrainData.refreshTime = data.refreshTime;
        lTrainData.httpStatus = HttpStatus.OK;
        lTrainData.tabId = tab.id;
        lTrainData.errorMessage = "";
        tab.subTypeDetail.data.message = "";
        if (
          locateLocoId &&
          lTrainData.locoDetails &&
          lTrainData.locoDetails.length > 0
        ) {
          for (let i = 0; i < lTrainData.locoDetails.length; i++) {
            const locoD = lTrainData.locoDetails[i];
            if (
              locoD &&
              locoD.locomotiveIdentifier &&
              !lTrainData.isLocated &&
              this.appUtilService.UIformatLocomotiveId(
                locoD.locomotiveIdentifier
              ) === this.appUtilService.UIformatLocomotiveId(locateLocoId)
            ) {
              locoD.isLocated = true;
              lTrainData.isLocated = true;
              break;
            }
          }
        }
        this.dataStoreService.putValue(tab, tabData);
        this.loadDataBS.next(lTrainData);
        this.lmsLoggerService.logInfo(
          "TrainDataService => load()",
          `Train Data Fetch Successfull for ${JSON.stringify(tab)}`
        );

        if (fromOtherOperation) {
          this.messageHandlerService.handleMessage(<MessageDetails>{
            type: this.configData.message.type.client,
            level: this.configData.message.level.success,
            target: this.configData.message.target.page,
            message: messageText,
          });
        }
      } else {
        const lTrainData = <TrainData>{
          httpStatus: 400,
          errorMessage: fromOtherOperation
            ? messageText + ", but " + data.messageText
            : data.messageText,
        };
        this.loadDataBS.next(lTrainData);
        this.lmsLoggerService.logError(
          "TrainDataService => load()",
          data.messageText
        );
      }
      this.lmsLoaderService.hideLoader();
    }
    this.lmsLoggerService.logInfo("TrainDataService=>load service call ends");
  }

  /**
   * This is service call to http server to make
   * add train request
   * @param {*} trainId
   * @returns {Observable<Response>}
   * @memberOf TrainDataService
   */
  addTrain(trainId: any): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    const opr = "TADD";
    const win = "LWTD";
    
    this.lmsLoggerService.logInfo(
      "TrainDataService=>addTrain service call starts"
    );
    return this.http
      .post<any>(
        `${apiUrl}${this.RESOURCE_URL}${trainId}?opr=${opr}&win=${win}`,
        null
      )
      .pipe(
        tap(() =>
          this.lmsLoggerService.logInfo(
            "TrainDataService=>addTrain service call ends"
          )
        )
      );
  }

  /**
   * This is service call to http server to make
   * cancel or complete train request
   * @param {TrainCancelComplete} trainCancelComplete
   * @param {*} opr
   * @returns {Observable<Response>}
   * @memberOf TrainDataService
   */
  cancelCompleteTrain(
    trainCancelComplete: TrainCancelComplete,
    opr: any
  ): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    const win = "LWTD";
    headers = headers.append("Content-Type", "application/json");
    const options = { headers: headers };
    this.lmsLoggerService.logInfo(
      "TrainDataService=>cancelCompleteTrain service call starts"
    );
    return this.http
      .put<any>(
        `${apiUrl}${this.RESOURCE_URL}?opr=${opr}&win=${win}`,
        JSON.stringify(trainCancelComplete),
        options
      )
      .pipe(
        tap(() =>
          this.lmsLoggerService.logInfo(
            "TrainDataService=>cancelCompleteTrain service call ends"
          )
        )
      );
  }

  /**
   * This is service call to http server to make
   * set train position request
   * @param {string} trainId
   * @returns
   * @memberOf TrainDataService
   */
  setTrainPosition(trainId: string) {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    const opr = "TSET";
    const win = "LWTD";

    this.lmsLoggerService.logInfo(
      "TrainDataService=>setTrainPosition service call starts"
    );
    return this.http
      .put<any>(
        `${apiUrl}${this.RESOURCE_URL}${trainId}?opr=${opr}&win=${win}`,
        null
      )
      .pipe(
        tap(() =>
          this.lmsLoggerService.logInfo(
            "TrainDataService=>setTrainPosition service call ends"
          )
        )
      );
  }

  /**
   * This is service call to http server to make
   * resequenceLocomotives request to this train
   * @param {*} request
   * @param {string} terminalId
   * @returns
   * @memberOf TrainDataService
   */
  resequenceLocomotives(request: any, terminalId: string) {
    const apiUrl = this.configData.urls.API_URL;
    const RESOURCE_URL = "/terminals/";
    let headers = new HttpHeaders();
    const opr = "RSEQ";
    const win = "LWTD";

    headers = headers.append("Content-Type", "application/json");
    const options = { headers: headers };
    this.lmsLoggerService.logInfo(
      "TrainDataService=>resequenceLocomotives service call starts"
    );
    return this.http
      .put<any>(
        `${apiUrl}${RESOURCE_URL}${terminalId}/locomotives?opr=${opr}&win=${win}`,
        JSON.stringify(request),
        options
      )
      .pipe(
        tap(() => this.lmsLoggerService.logInfo("TrainDataService=>resequenceLocomotives service call ends"))
      );
  }

  /**
   * This is service call to http server to make
   * cancel locomotives plan request
   * @param {*} request
   * @param {string} terminalId
   * @returns
   * @memberOf TrainDataService
   */
  cancelLocomotivePlan(request: any, terminalId: string) {
    const apiUrl = this.configData.urls.API_URL;
    const RESOURCE_URL = "/terminals/";
    let headers = new HttpHeaders();
    const opr = "CPLN";
    const win = "LWTD";

    headers = headers.append("Content-Type", "application/json");
    const options = { headers: headers };
    this.lmsLoggerService.logInfo(
      "TrainDataService=>cancelLocomotivePlan service call starts"
    );
    return this.http.put<any>(
        `${apiUrl}${RESOURCE_URL}${terminalId}/thp?opr=${opr}&win=${win}`,
        JSON.stringify(request),
        options
      )
      .pipe(
        tap(() => this.lmsLoggerService.logInfo("TrainDataService=>cancelLocomotivePlan service call ends"))
      );
  }

  /**
   * This is service call to http server to make
   * transfer locomotives request
   * @param {Array<LocoTransfer>} locoTransfer
   * @param {string} operation
   * @returns {Observable<Response>}
   * @memberOf TrainDataService
   */
  transferLocomotive(
    locoTransfer: Array<LocoTransfer>,
    operation: string
  ): Observable<Response> {
    let headers = new HttpHeaders();
    const apiUrl = this.configData.urls.API_URL;
    const RESOURCE_URL = "/locomotives/";
    const windowCode = "LWTD";
    headers = headers.append("Content-Type", "application/json");
    const options = { headers: headers };
    this.lmsLoggerService.logInfo(
      "TrainDataService=>transferLocomotive service call starts"
    );
    return this.http
      .put<any>(
        `${apiUrl}/locomotives?opr=${operation}&wc=${windowCode}`,
        JSON.stringify(locoTransfer),
        options
      )
      .pipe(
        tap(() => this.lmsLoggerService.logInfo("TrainDataService=>transferLocomotive service call ends"))
      );
  }

  resetAll() {
    // this.editModeService.setEditResetMode(true);
    // this.editModeService.setEditMode({ status: false, message: '' });
    // will set things as per out need but right now its need to be defined
  }
  /**
   * This is service call to http server to make
   * update locomotive request
   * @param {*} editRequest
   * @returns {Observable<Response>}
   * @memberOf TrainDataService
   */
  trainLocomotiveUpdate(editRequest: any): Observable<Response> {
    let headers = new HttpHeaders();
    const apiUrl = this.configData.urls.API_URL;
    const RESOURCE_URL = "/locomotives/train";
    const windowCode = "LWTD";
    const opr = "GRID";
    headers = headers.append("Content-Type", "application/json");
    const options = { headers: headers };
    this.lmsLoggerService.logInfo(
      "TrainDataService=>trainLocomotiveUpdate service call starts"
    );
    return this.http
      .put<any>(
        `${apiUrl}${RESOURCE_URL}?opr=${opr}&wc=${windowCode}`,
        JSON.stringify(editRequest),
        options
      )
      .pipe(
        tap(() => this.lmsLoggerService.logInfo("TrainDataService=>trainLocomotiveUpdate service call ends"))
      );
  }

  /**
   * @memberOf TrainDataService
   */
  cleanBehaviourSubject() {
    this.loadDataBS.next(null);
  }

  /**
   * Service request for bre execption in transfer to train.
   * @param {Array<String>} locoList
   * @param {string} trainId
   * @returns {Observable<Response>}
   * @memberOf TrainDataService
   */
  breTransferRequest(
    locoList: Array<String>,
    trainId: string
  ): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", "application/json");
    const options = { headers: headers };
    this.lmsLoggerService.logInfo(
      "TrainDataService=>breTransferRequest service call starts"
    );
    return this.http
      .put<any>(
        `${apiUrl}/trains/${trainId}/breparam?opr=INQU`,
        JSON.stringify(locoList),
        options
      )
      .pipe(
        tap(() => this.lmsLoggerService.logInfo("TrainDataService=>breTransferRequest service call ends"))
      );
  }
}
